<template>
  <f7-page class="search-lesson">
    <f7-navbar :sliding="false">
      <f7-nav-left>
        <user-info-item
          :emoji="user.status.image"
          :title="`${user.lastName} ${user.name}`"
          :is-data-load="true"
          :link-text="user.status.name"
        ></user-info-item>

        <user-info-item
          emoji="$"
          :title="user.balance"
          :is-data-load="true"
          :link-text="$t('by_more_credits')"
        ></user-info-item>

        <!-- <user-info-item
          emoji="⭐️"
          :title="user.coin"
          :is-data-load="true"
        ></user-info-item> -->
      </f7-nav-left>
    </f7-navbar>
    <div class="page-content-inner justify-content-center">
      <!-- <img class="search-lesson-bg-image" src="static/search-bg.svg" alt="bg" /> -->
      <img
        src="static/flower1.svg"
        alt="alt"
        class="search-lesson-decor first"
      />
      <img
        src="static/flower2.svg"
        alt="alt"
        class="search-lesson-decor second"
      />
      <img
        src="static/flower3.svg"
        alt="alt"
        class="search-lesson-decor third"
      />

      <div class="search-lesson-wrapper mt-auto">
        <div class="search-lesson-teacher-count">
          <b>{{ teacherCounter }}</b>
          {{ $t(`page_search_lesson.are_ready_now`) }}
        </div>

        <search-preloader></search-preloader>

        <div class="search-lesson-countdown">
          {{ $t(`page_search_lesson.wait_connection`) }}

          <countdown
            :date="request.end"
            @finish="handleRemoveRequest"
          ></countdown>
        </div>
      </div>

      <f7-block
        class="search-lesson-actions mt-auto display-flex flex-column align-items-center"
      >
        <f7-button class="custome-large" fill large @click="renewRequest">
          {{ $t(`page_search_lesson.wait_more`) }}
          <f7-preloader
            v-if="loading"
            class="margin-left"
            color="white"
          ></f7-preloader>
          <f7-icon
            v-else
            class="margin-left"
            f7="arrow_2_circlepath"
            color="white"
            size="24"
          ></f7-icon>
        </f7-button>

        <span v-if="!appConfig.isShowBooking" class="link-with-label">
          <span>{{ $t(`or`) }}</span>
          <f7-link href="/booking">{{ $t(`booking.book_time`) }}</f7-link>
        </span>

        <f7-link
          class="search-lesson-actions-cancel"
          @click="handleRemoveRequest"
        >
          {{ $t(`cancel`) }}
        </f7-link>
      </f7-block>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import notify from '@/js/helpers/notify.js';

import UserInfoItem from '@/components/UserInfoItem.vue';
import SearchPreloader from '@/components/SearchPreloader.vue';
import Countdown from '@/components/Countdown.vue';

export default {
  name: 'SearchLesson',

  components: {
    SearchPreloader,
    UserInfoItem,
    Countdown
  },

  data() {
    return {
      teacherCounter: 0,
      interavalId: null,
      loading: false
    };
  },

  computed: {
    ...mapState({
      appConfig: (state) => state.appConfig,
      user: (state) => state.user.info,
      request: (state) => state.request.request
    })
  },

  created() {
    this.teacherCounter = this.request.teachersCount;
    this.updateTeacherCount();
  },

  beforeDestroy() {
    clearInterval(this.interavalId);
  },

  methods: {
    getTeacherCounter(count = 10) {
      const min = count - 5;
      const max = count + 5;

      return Math.abs(Math.floor(Math.random() * (max - min)) + min);
    },

    async renewRequest() {
      const { languageId, levelId } = this.request;
      this.loading = true;
      try {
        await this.createRequest({ languageId, levelId });
        this.loading = false;
      } catch (error) {
        this.loading = false;
        if (error.customeError && error.customeError.type === 'LOW_BALANCE') {
          notify({ text: this.$t(`notify.low_balance`) });
          // this.$f7.views.main.router.navigate('/balance', {
          //   clearPreviousHistory: true
          // });
        } else {
          notify({ text: this.$t(`notify.something_went_wrong`) });
        }
      }
    },

    async handleRemoveRequest() {
      const { id } = this.request;
      try {
        await this.removeRequest({ id });
        this.$f7.views.leftPanel.router.navigate('/main-panel', {
          clearPreviousHistory: true
        });
      } catch (error) {
        if (error.customeError) {
          notify({ text: error.customeError });
        } else {
          notify({ text: this.$t(`notify.something_went_wrong`) });
        }
      }
    },

    updateTeacherCount() {
      let intervalTime = Math.round(Math.random() * (20000 - 5000)) + 5000; // max = 20sec; min = 5sec;

      clearInterval(this.interavalId);

      this.interavalId = setInterval(() => {
        this.teacherCounter = this.getTeacherCounter(
          this.request.teachersCount
        );

        this.updateTeacherCount();
      }, intervalTime);
    },
    ...mapActions({
      createRequest: 'request/createRequest',
      removeRequest: 'request/removeRequest'
    })
  }
};
</script>

<style lang="less">
.search-lesson {
  &-bg-image {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: auto;
    transform: translateY(-50%);
  }

  &-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;
  }

  &-teacher-count {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    text-transform: uppercase;

    b {
      font-weight: 800;
      font-size: 60px;
      color: #86909b;
      line-height: 71px;
    }
  }

  &-countdown {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 11px;
    text-transform: uppercase;

    .countdown {
      margin-top: 5px;
    }
  }

  &-actions {
    &-wait-more {
      margin-top: -70px;
      // margin-bottom: 20px;

      --f7-button-height: 50px;
      --f7-button-padding-horizontal: 20px;

      .icon {
        margin-left: 10px;
      }
    }

    &-cancel {
      font-size: 17px;
    }
  }
}

.search-lesson-decor {
  position: absolute;
  z-index: -1;

  &.first {
    top: 70px;
    right: 50px;
  }

  &.second {
    bottom: 70px;
    right: 50px;
  }

  &.third {
    bottom: 40%;
    left: 20px;
  }
}
</style>
